// This function serves as the callback for /include/home-recents-scroller-data.js
window.callback_recent_scroller = function(data)
{
    var $container = $('.hp-recents-container');

    // Populate with items from data

    var output = '';
    var counter = 1;

    output += '<ul id="recents_carousel" class="slides">';

    $.each(data.rss.item, function(i,item){ //LOOPS THROUGH EACH ITEM

        if(item.media['content']['url']!=""){ //ITEM MUST HAVE AN IMAGE

            var split_author = item.author.split(",");
            var author_name = split_author[0];
            //image = '<img class="tmb" src="'+item.media['content']['url']+'" />'; //_1_
            //var image = '<img class="tmb" src="'+item.media['thumbnail']['url']+'" />'; //_3_
            var image = '<picture>';
            
            if(typeof item.media['thumbnail']['url_webp'] !== 'undefined' && item.media['thumbnail']['url_webp'] !== '' ){
                image += '<source srcset="'+ item.media['thumbnail']['url_webp'] +'" type="image/webp" >';
            }
            image += '<img srcset="'+ item.media['thumbnail']['url'] +'" alt="'+ item.title +'" type="image/jpg">';
            image += '</picture>';

            var output_item = '';

            if(counter<=24){

                output_item += '<li class="video">';
                output_item += '<div class="image">';
                output_item += '<a href="'+item.link+'">'+image+'</a>';
                output_item += '</div>';
                output_item += '<p class="info">';
                output_item += '<a href="'+item.link+'">';
                output_item += '<em>'+author_name+'</em>: '+ item.title;
                output_item += '</a>';
                output_item += '</p>';
                output_item += '<div class="buffer"></div>';
                output_item += '</li>';
            }

            output += output_item;

            counter += 1;
        }
    });

    output += '</ul>';
    //output += '<a class="video_nav" id="prev" href="javascript:void(\'0\');">&laquo;</a> <a class="video_nav" id="next" href="javascript:void(\'0\');">&raquo;</a>';

    $container.children("#entries").html(output);

    var grid_size = get_grid_size_recents();

    $container.children("#entries").flexslider({
        animation: "slide",
        slideshowSpeed: 15000,
        controlNav: false,
        itemWidth: 210,
        minItems: grid_size,
        maxItems: grid_size
    });

    $(window).resize(throttle_resize_recents);
}

function init_scroller()
{
    $.getJSON(SITE_INFO['global_site_url']+'/include/home-recents-scroller-data.js?callback=?');
}

export default init_scroller;